export const getUnexpectedErrorMessages = (
  section: 'trees' | 'items' | 'subitems',
  action: 'create' | 'edit' | 'duplicate' | 'arrange',
) => {
  const sectionName = { trees: 'el árbol de navegacion', items: 'el mundo', subitems: 'el submundo' };
  const actionVerb = { create: 'creaba', edit: 'editaba', duplicate: 'duplicaba', arrange: 'ordenaba' };
  const errorMessage = `Error inesperado mientras se ${actionVerb[action]} ${sectionName[section]}`;
  return errorMessage;
};
